/**
 * The agency's books checked against each other, for the Money page, on the
 * signed-in agent's session. The rule and the reversal live in
 * shared/agencyBooks.ts, which the Claude connector runs too.
 */

import { pb, escapeFilterValue } from '../lib/pocketbase'
import { ensureUserAgency } from '../utils/ensureAgency'
import { loadBalances, reverseBookedCommission as reverse, type Balances } from '../shared/agencyBooks'

export type { Balances } from '../shared/agencyBooks'

export async function reverseBookedCommission(rowId: string, userId: string): Promise<{ reversed: number }> {
  return reverse(pb, rowId, userId)
}

export async function getBalances(): Promise<Balances> {
  const agencyId = await ensureUserAgency()
  return loadBalances(pb, `agency_id = "${escapeFilterValue(agencyId)}"`)
}
